import { useEffect, useState } from "react";
import Modals from "../../components/common/Modal";
import TestLinkModel from "../TestLink/TestModel";
import InvoiceList from "./invoiceList";

function InvoiceListModal({ open, setOpen, modalRight }) {

  const userRoleCode = atob(localStorage.getItem("argument6"));
  const [showSignerModal, setShowSignerModal] = useState(false)

  useEffect(() => {
    if (open === "InvoiceListModal") {
      const fetchData = async () => {
        try {
          const response = await fetch('https://localhost:29739/');
          if (response) {
            setShowSignerModal(false)
          }
        } catch (error) {
          console.error("Error fetching data: ", error);
          setShowSignerModal(true)
        }
      };
      fetchData();
    }
  }, [open]);
  return (
    <>
      <Modals
        title={"Invoice List"}
        show={open === "InvoiceListModal"}
        handleClose={() => setOpen("")}
        size="xl"
      >
        <InvoiceList
          modalRight={
            open === "createAuctionCenter" ||
            (open === "editingAuctionCenterData" || modalRight?.length > 0
              ? modalRight
              : [])
          }
        />
      </Modals>
      {(userRoleCode == "AUCTIONEER" || userRoleCode == "TEABOARDUSER") &&
        showSignerModal && (
          <TestLinkModel
            open={showSignerModal}
            setOpen={setShowSignerModal}
          />
        )
      }
    </>
  );
}

export default InvoiceListModal;
